module.exports = __webpack_public_path__ + "img/studio_collaboration.1e49fa73.png";